import { useState, useRef, useCallback } from 'react';

export function usePreventDoubleClick(callback) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isRunning = useRef(false);

    const safeCallback = useCallback(async (...args) => {
        if (isRunning.current) return;

        isRunning.current = true;
        setIsSubmitting(true);

        try {
            await callback(...args);
        } catch (error) {
            // erros são tratados na função original
        } finally {
            isRunning.current = false;
            setIsSubmitting(false);
        }
    }, [callback]);

    return [safeCallback, isSubmitting];
}
